import React, { useContext, useState } from 'react'
import { WrapperData } from '../../style/style'
import { Empty, Layout } from 'antd'
import { Content } from 'antd/es/layout/layout'
import Sider from 'antd/es/layout/Sider'
import WrapperTextPage from '../../modules/WrapperTextPage/WrapperTextPage'
import DynamicMenu from '../../modules/DynamicMenu/DynamicMenu'
import { useParams } from 'react-router-dom'
import { AppContext } from '../../App'
import { ContextType } from '../../type/type'

const OurEverything = () => {
  const { type = '9' } = useParams()
  const [menuActive, setMenuActive] = useState(false)
  const [collapsed, setCollapsed] = useState(false)
  const [breakpoint, setBreakpoint] = useState(false)
  const { isMobileWidth } = useContext<ContextType>(AppContext)

  const handleCollapse = (collapsed: boolean, type: string) => {
    if (type === 'clickTrigger') setCollapsed(collapsed)
  }

  const handleClickMenu = () => {
    if (breakpoint) setCollapsed(true)
  }

  return (
    <Layout className="br-12">
      { isMobileWidth ? 
        <DynamicMenu
        defaultType="9"
        url="our-everything"
        setMenuActive={setMenuActive}
        handleClickMenu={handleClickMenu}
      />
      :
      <Sider
        width={270}
        breakpoint="lg"
        collapsedWidth="0"
        className="site-layout-background"
        collapsed={collapsed}
        onBreakpoint={(broken) => setBreakpoint(broken)}
        onCollapse={(collapsed: boolean, type: string) => handleCollapse(collapsed, type)}
      >
        <DynamicMenu
          defaultType="9"
          url="our-everything"
          setMenuActive={setMenuActive}
          handleClickMenu={handleClickMenu}
        />
      </Sider>
      }
      <Content>
        <WrapperData>
          {menuActive ? <WrapperTextPage id={type} /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
        </WrapperData>
      </Content>
    </Layout>
  )
}

export default OurEverything
